import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanGroupModel } from 'src/app/models/planGroup.model';
import { PlanModel } from 'src/app/models/plan.model';
import { SubscriptionService } from './subscription.service';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: false,
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent {

  models: PlanGroupModel[];
  selectedTabId = "";
  faInfo = faInfo;

  constructor(private activatedRoute: ActivatedRoute, private subscriptionService: SubscriptionService) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ subscriptionTemplates }) => {
      this.models = subscriptionTemplates;
      this.selectedTabSelector(this.models);
    })
  }
  selectedTabSelector(tabs: PlanGroupModel[]){
    tabs.forEach(element => {
      console.log(element);
      if(element.isSelected){
        this.selectedTabId = element.id;
      }
    });
  }

  onSubscribe(planId: string) {
    this.subscriptionService.getSubscriptionSession(planId).subscribe({
      next: (response: any) => {
        window.location.href = response.stripeUrl;
      },
      error: (err) => {
        console.error('Failed to create subscription session', err);
      }
    });
  }
}
